import { init } from "marko/dist/runtime/components/index.js";
import "../../components/app-layout/style.less";
import "../../components/sample-header/index.marko";
import "../../components/sample-footer/style.less";
import "../../components/menu/index.marko";
import "../../components/app-search/index.marko";
init("online_tools");